import { configureStore } from '@reduxjs/toolkit';

// Common importsp
import navbarTopSlice from '../../common/slices/navbarTop';
import createUserReducer from '../createUser/createUserSlice';
import dashboardReducer from '../dashboard/slices/dashboardSlice';
import instructionReducer from '../dashboard/slices/instructionSlice';
import creditBalanceReducer from '../../common/slices/creditBalanceSlice';
import notificationReducer from '../../common/slices/notificationSlice';
import requestedTableReducer from '../dashboard/slices/requestedTableSlice';
import releasedTableReducer from '../dashboard/slices/releasedTableSlice';
import docPendingTableReducer from '../dashboard/slices/docPendingTableSlice';
import documentHistoryReducer from '../blDetails/slices/documentHistorySlice';
import eBLDocumentHistoryReducer from '../ebl/slices/eBLDocumentHistorySlice';
import blDetailsTableReducer from '../blDetails/slices/blDetailsTable';
import blPaymentReducer from '../blPayment/slices/blPaymentSlice';
import creditBalanceBlPaymentReducer from '../blPayment/slices/creditBalance';
import blSliceReducer from '../blDetails/slices/BlSlice';
import getInvoiceRequestPaymentReducer from '../blPayment/slices/getInvoiceSlice';

import paymentBlPaymentReducer from '../blPayment/slices/PaymentInvoiceSlice';
import customerMsgTableReducer from '../dashboard/slices/customerMsgTable';
import BlRequestInsReducer from '../blRequestInstruction/blRequestInsSlice';
import MultiBlPaymentReducer from '../multiBlPayment/slices/multiBlPaymentSlice';
import PaymentReducer from '../payment/paymentSlice';
import RegistrationReducer from '../registration/registraionSlice';

import CustomerCodeReducer from '../customerCodeDashboard/CustomerCodeSlice';
import NominationReq from '../nominationReq/slices/nominationReq';
import StandingInstructionTable from '../standingInstruction/slices/standingInstructionTable';
import DataTableReducer from '../../common/components/DataTable/slices/DataTable';
import ThemeSettingsReducer from '../settings/slices/themeSettings';
import DocumentViewReducer from '../../common/slices/documentViewSlice';
import NavbarVerticalReducer from '../../common/slices/navbarVertical';
import ColumnConfigurationReducer from '../settings/slices/columnConfiguration';
import FilterViewCommon from '../../common/slices/filterView';
import RegistrationCompanyReducer from '../registration/registrationCompanySlice';
import CoreorReducer from '../coreor/coreorSlice';
import OblDetailReducer from '../../common/components/OblDetailSlice';
import EblDetailReducer from '../ebl/slices/eBLDetailSlice';
import CarrierHaulageSlice from '../blRequestInstruction/components/instructionSlice/CarrierHaulageSlice';
import InvoiceChangeSlice from '../blRequestInstruction/components/instructionSlice/InvoiceChangeSlice';
import ExportInvoiceChangeSlice from '../blRequestInstruction/components/instructionSlice/ExportInvoiceChangeSlice';
import DashboardCSVSlice from '../dashboard/slices/dashboardcsvSlice';
import AgentNominationSlice from '../blRequestInstruction/components/instructionSlice/AgentNominationSlice';
import DemurrageSlice from '../blRequestInstruction/components/instructionSlice/DemurrageSlice';
import DemurrageSliceView from '../blRequestInstruction/components/instructionSlice/DemurrageSlice';
import DemurrageViewSlice from '../blRequestInstruction/components/instructionSlice/DemurrageViewSlice';
import loginSlice from '../registration/loginSlice';
import ProfileAccountSlice from '../profile/profileAccountSlice';
import vanBalanceReducer from '../../common/slices/vanBalanceSlice';
import userDetailsSlice from '../../common/slices/userDetails';
import userDetailsListReducers from '../createUser/UserDetailsSlice';
import customerCodeListReducers from '../customerCodeDashboard/CustomerCodeDashboardSlice';
import { instructionDashboardSlice } from '../instructionDashboard/slices/dashboardSlice';
import { instructionDetailsTableSlice } from '../instructionDashboard/slices/instructionDetailsTable';
import ReturnSlice from '../blRequestInstruction/components/instructionSlice/ReturnSlice';
import ReturnViewSlice from '../blRequestInstruction/components/instructionSlice/ReturnViewSlice';
import PickupSlice from '../blRequestInstruction/components/instructionSlice/PickupSlice';
import { paymentBlPayment } from '../blPayment/slices/PaymentInvoiceSlice';
import standingInstructionTableSlice from '../standingInstruction/slices/standingInstructionTable';
import loadingMiddleware, { loadingSlice } from '../../../middleware/loadingMiddleware';
import standaloneInvoicePaymentSlice from '../blPayment/slices/standaloneInvoicePaymentSlice';
import { paymentDashboardSlice } from '../paymentdashboard/paymntDashSlice';

import { emailDashboardSlice } from '../emailDashboard/emailDashboardSlice';
import { payorDashboardSlice } from '../payorDashboard/payorDashboardSlice';

import { registerDashboardSlice } from '../registrationMaster/slices/dashboardSlice';
import { reportDashboardSlice } from '../reportDashboard/reportSlice';
import { snoozeSlice } from '../dashboard/slices/snoozeSlice';
import unpaidReducer from '../crrpop/InvoiceUnpaidSlice'
import { overstayExtensionSlice } from '../blRequestInstruction/components/instructionSlice/OverstayExtensionSlice';
import quickPayReducer from '../quickpay/quickPaySlice'
import MappingDashSlice, { mappingDashboardSlice } from '../customerMappingDashboard/MappingSlice';
import { sezDashboardSlice } from '../sezDashboard/SezSlice';
import { getInGetOutDashboardSlice } from '../getInGetOutDashboard/getInGetOutDashSlice';
import { truckDashboardSlice } from '../truckerMasterDashboard/truckDashSlice';
import templateSlice from '../../../templateSlice';
import formDirtyReducer from '../formDirtySlice';
import DocumentMasterSlice from '../documentManagment/DocumentManagementSlice';
import { NewBlRequestSlice } from '../payorDashboard/NewBlRequestSlice';
import { RefundSlice } from '../refund/RefundSlice';
import { InvoiceRequestSlice } from '../invoiceRequest/InvoiceRequestSlice';
import invoiceRequestContainerReducer from '../invoiceRequest/InvoiceRequestContainerSlice';
import eblConsentReducer from "../ebl/slices/eBLConsentSlice";
import eblConsentProfileReducer from "../profile/slices/eblConsentProfileSlice"
import { DoExtensionSlice } from '../blRequestInstruction/components/instructionSlice/DOExtensionSlice';

export const store = configureStore({
  reducer: {
    createUser: createUserReducer,
    dashboard: dashboardReducer,
    helpDocument: DocumentMasterSlice.reducer,
    creditBalance: creditBalanceReducer,
    vanBalance: vanBalanceReducer,
    notification: notificationReducer,
    requestedTable: requestedTableReducer,
    releasedTable: releasedTableReducer,
    docPendingTable: docPendingTableReducer,
    documentHistory: documentHistoryReducer,
    eBLDocumentHistory: eBLDocumentHistoryReducer,
    blDetailsTable: blDetailsTableReducer,
    customerMsgTable: customerMsgTableReducer,
    blPayment: blPaymentReducer,
    creditBalanceBlPayment: creditBalanceBlPaymentReducer,
    blSlice: blSliceReducer,
    getInvoiceSlice:getInvoiceRequestPaymentReducer,
    paymentBlPayment: paymentBlPaymentReducer,
    blRequestInstruction: BlRequestInsReducer,
    multiBlPayment: MultiBlPaymentReducer,
    payment: PaymentReducer,
    nominationReq: NominationReq,
    standingInstructionTable: StandingInstructionTable,
    dataTable: DataTableReducer,
    themeSettings: ThemeSettingsReducer,
    instructionSlice: instructionReducer,
    templateSlice:templateSlice,
    documentView: DocumentViewReducer,
    navbarVertical: NavbarVerticalReducer,
    columnConfiguration: ColumnConfigurationReducer,
    filterViewCommon: FilterViewCommon,
    registration: RegistrationReducer,
    registrationCompany: RegistrationCompanyReducer,
    customerCodeRequest: CustomerCodeReducer,
    coreor: CoreorReducer,
    oblDetails: OblDetailReducer,
    eblDetails: EblDetailReducer,
    carrierHaulage: CarrierHaulageSlice,
    invoiceChange: InvoiceChangeSlice,
    exportInvoiceChange: ExportInvoiceChangeSlice,
    dashboardcsv: DashboardCSVSlice,
    navbarTop: navbarTopSlice,
    agentDelegation: AgentNominationSlice,
    demurrage: DemurrageSlice,
    newBlRequest: NewBlRequestSlice.reducer,
    refund: RefundSlice.reducer,
    invoiceRequest: InvoiceRequestSlice.reducer,
    invoiceRequestContainer: invoiceRequestContainerReducer,
    demurrageView: DemurrageSliceView,
    demurrageViewSlice: DemurrageViewSlice,
    loginDetails: loginSlice,
    partnerData: ProfileAccountSlice,
    userProfile: userDetailsSlice,
    userList: userDetailsListReducers,
    customerCodeList: customerCodeListReducers,
    standingInstructionList: standingInstructionTableSlice,
    instructionDashboard: instructionDashboardSlice.reducer,
    registrationDashboard: registerDashboardSlice.reducer,
    instructionTable: instructionDetailsTableSlice.reducer,
    return: ReturnSlice,
    returnView: ReturnViewSlice,
    pickup: PickupSlice,
    standaloneInvoice: standaloneInvoicePaymentSlice,
    paymentDashboard: paymentDashboardSlice.reducer,
    truckDashboard:truckDashboardSlice.reducer,
    emailDashboard: emailDashboardSlice.reducer,
    payorDashboard: payorDashboardSlice.reducer,
    reportDashboard: reportDashboardSlice.reducer,
    loading: loadingSlice.reducer,
    snooze:snoozeSlice.reducer,
    invoiceUnpaid: unpaidReducer,
    overstay:overstayExtensionSlice.reducer,
    quickpay:quickPayReducer,
    mappingDashboard: mappingDashboardSlice.reducer,
    sezDashboard: sezDashboardSlice.reducer,
    getIngetOut:getInGetOutDashboardSlice.reducer,
    formDirty: formDirtyReducer,
    eblConsent: eblConsentReducer,
    eblConsentProfile: eblConsentProfileReducer,
    doExtension: DoExtensionSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([loadingMiddleware]),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
